export default "/images/cart-disabled.svg?901f6b54d6e605d987b0bdcac0d19594";